import * as React from "react";
import styled from "styled-components";
import {
  DataGrid,
  DataGridHeader,
  DataGridHeading,
  DataGridRow,
  DataGridCell,
  Main,
} from "@conserveit/blocks";
import ProgressiveList from "../ProgressiveList";

const Container = styled.div`
  width: 100%;
`;

interface User {
  user_id: number;
  user_username: string;
  user_email: string;
  user_fullname: string;
  user_role: string;
  user_group: string;
  status: string;
}

interface OwnProps {
  users: User[];
  user: User;
  onRowSelect: (user: User) => void;
}

export class UserTable extends React.PureComponent<OwnProps> {
  ref: any;

  constructor(props: OwnProps) {
    super(props);

    this.ref = React.createRef();
  }

  getInitialRenderCount = (userCount: number) => {
    // Determine if the group length is small enough to render all at once
    // If less than 6 groups, render all of em, otherwise limit to 6 initially
    const DEFAULT_RENDER_LIMIT = 30;
    return userCount > DEFAULT_RENDER_LIMIT ? DEFAULT_RENDER_LIMIT : userCount;
  };

  renderGroup = (index: number) => {
    const { users, onRowSelect } = this.props;
    const user = users[index];
    if (!user) return null;

    return (
      <DataGridRow
        data-cy="user-row"
        onClick={() => onRowSelect(user)}
        key={user.user_id}
        cursor="pointer"
      >
        <DataGridCell data-cy="user-fullName">
          <Main>{user.user_fullname}</Main>
        </DataGridCell>
        <DataGridCell data-cy="user-userName">
          <Main>{user.user_username}</Main>
        </DataGridCell>
        <DataGridCell data-cy="user-email">
          <Main>{user.user_email}</Main>
        </DataGridCell>
        <DataGridCell data-cy="user-role">
          <Main>{user.user_role}</Main>
        </DataGridCell>
        <DataGridCell data-cy="user-group">
          <Main>{user.user_group.split(",").join(", ")}</Main>
        </DataGridCell>
        <DataGridCell data-cy="user-status">
          <Main>{user.status}</Main>
        </DataGridCell>
      </DataGridRow>
    );
  };

  render() {
    const { users } = this.props;

    return (
      <Container ref={this.ref}>
        <DataGrid
          grow={[3, 5, 6]}
          cellProps={{ type: "dense", density: "default" }}
        >
          <DataGridHeader>
            <DataGridHeading>
              <Main>Full Name</Main>
            </DataGridHeading>
            <DataGridHeading>
              <Main>User Name</Main>
            </DataGridHeading>
            <DataGridHeading>
              <Main>Email</Main>
            </DataGridHeading>
            <DataGridHeading>
              <Main>Role</Main>
            </DataGridHeading>
            <DataGridHeading>
              <Main>Group</Main>
            </DataGridHeading>
            <DataGridHeading>
              <Main>Status</Main>
            </DataGridHeading>
          </DataGridHeader>

          <ProgressiveList
            initialAmount={this.getInitialRenderCount(users.length)}
            useWindowScroll
            progressiveAmount={30}
            renderItem={this.renderGroup}
            rowCount={users.length}
            scrollParent={this.ref}
          />
        </DataGrid>
      </Container>
    );
  }
}
